import styled from 'styled-components';
import type { TextStyleValue } from '@elfsight/configurator-contracts';
import { textColorMixin, textStyleMixin } from '@elfsight/widget-ui';
import { paragraphDefaultTextStyle } from './ParagraphDefaultSettings';

interface ParagraphProps {
  text?: string;
  fieldParagraphColor?: string;
  fieldParagraphFontStyle?: TextStyleValue;
}

export function Paragraph({
  text = '',
  fieldParagraphColor,
  fieldParagraphFontStyle = paragraphDefaultTextStyle
}: ParagraphProps) {
  return (
    <ParagraphControl
      _textStyle={fieldParagraphFontStyle}
      _textColor={fieldParagraphColor}
      dangerouslySetInnerHTML={{ __html: text }}
    />
  );
}

const ParagraphControl = styled.div<{
  _textStyle?: TextStyleValue;
  _textColor?: string;
}>`
  ${textStyleMixin}
  ${textColorMixin}
`;
